"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(v, current, value) {
  var result = new Date(value == null ? current : value);
  var year = v.year,
      month = v.month,
      date = v.date;
  if (year != null) result.setFullYear(year);
  if (month != null) result.setMonth(month);
  if (date != null) result.setDate(date);
  return result;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@z-r/calendar/lib/view/getChangedValue.js
// module id = 1339
// module chunks = 6 7 17 18